module.exports = __webpack_public_path__ + "static/media/img-noproject.c52801f2.png";